<template lang="html">
  <div class="wide-select setting-select-wrapper">
    <span class="UI-icon UI-expand" />
    <select
      v-model="templateName"
      class="setting-input"
    >
      <option
        v-for="template in templates"
        :key="template.name"
        :selected="template.name === templateName"
        :value="template.name"
      >
        {{ $t(`templates.title.${template.name}`) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'TemplateSelector',

  props: {
    templates: { type: Array, required: true },
    defaultTemplateName: { type: String, required: true },
    toolkitUiRouting: { type: Object, required: true }
  },

  data () {
    return {
      templateName: this.defaultTemplateName
    }
  },

  watch: {
    templateName (newTemplate) {
      if (this.toolkitUiRouting.changeRoute) {
        this.toolkitUiRouting.changeRoute(newTemplate)
      } else {
        this.$emit('changeTemplate', newTemplate)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/variables";
  @import "~@/assets/styles/buttons";

  $inputHeight: 24px;

  .wide-select {
    width: 100%;
    margin-bottom: 40px;

    &:before{
      content: '';
      display: block;
      position: absolute;
      left: -48px;
      $triangle_width: 12px;
      top: 8px;
      border-top: $triangle_width solid transparent;
      border-left: $triangle_width solid white;
      border-bottom: $triangle_width solid transparent;
    }
  }

  .setting-input-wrapper {
    width: 100%;
    display: flex;

    button {
      .UI-delete {
        color: #A2b4b4;
      }
      &:hover {
        .UI-delete {
          color: white;
        }
      }
    }
  }

  .setting-input {
    display: block;
    width: 100%;
    height: $inputHeight;
    line-height: $inputHeight - 4;
    padding: 24px 7px;
    font-family: $poppins;
    border: 1px solid transparent;
    border-radius: 5px;

    &:focus {
      border: 1px solid #757573;
      box-shadow: 0 0 5px #757573;
    }

    &.highlight {
      border: 1px solid tomato;
      box-shadow: 0 0 5px tomato;
    }
  }
</style>
